export const ExceptionTypeInt = Object.freeze({
  Crash: 0,
  Native: 1,
  AllCatched: 2,
  AllCrash: 2,
  ANR: 3,
  Unity3D: 4,
  ExtensionCrash: 5,
  Lua: 6,
  JS: 7,
  OOM: 9,
  JankRaw: 40,
  JankParsed: 41,
  Hang: 43,
  MetricKitCrash: 44,
  /** 王者 ThreadMonitor 内部定制：协议 type="145"，ES issueExceptionType=45；UI 走错误大类 */
  JankV2: 45,
  MetricKitCpu: 46,
  MetricKitDisk: 47,
  AexitCrash: 60,
  AexitAnr: 61,
});

export const ExceptionTypeName = Object.freeze({
  Crash: 'Crash',
  Native: 'Native',
  AllCatched: 'AllCatched',
  AllCrash: 'AllCrash',
  ANR: 'ANR',
  Unity3D: 'Unity3D',
  ExtensionCrash: 'ExtensionCrash',
  Lua: 'Lua',
  JS: 'JS',
  OOM: 'OOM',
  JankRaw: 'JankRaw',
  JankParsed: 'JankParsed',
  Hang: 'Hang',
  MetricKitCrash: 'MetricKitCrash',
  /** 王者 ThreadMonitor 内部定制：协议 type="145"；侧栏文案 ThreadMonitor */
  JankV2: 'JankV2',
  MetricKitCpu: 'MetricKitCpu',
  MetricKitDisk: 'MetricKitDisk',
  AexitCrash: 'AexitCrash',
  AexitAnr: 'AexitAnr',
});

export const EXCEPTION_TYPE_INT_ANDROID_JAVA = ExceptionTypeInt.Crash;
export const EXCEPTION_TYPE_INT_ANDROID_NATIVE = ExceptionTypeInt.Native;

/**
 * 将issueExceptionType / crashExceptionType 转为b**ly那帮人搞出来的“exceptionType”这种烂玩意，这个东西很多页面都有用到
 * @param exceptionTypeInt
 * @returns {'crashes' | 'blocks' | 'errors'}
 */
export function getReportCategoryByExceptionTypeInt(exceptionTypeInt) {
  exceptionTypeInt = Number(exceptionTypeInt);
  if ([0, 1, 5].includes(exceptionTypeInt)) {
    return 'crashes';
  }
  if (exceptionTypeInt === 3) {
    return 'blocks';
  }
  if (exceptionTypeInt === ExceptionTypeInt.JankRaw || exceptionTypeInt === ExceptionTypeInt.JankParsed) {
    return 'janks';
  }
  if (exceptionTypeInt === ExceptionTypeInt.Hang) {
    return 'hangs';
  }
  if (exceptionTypeInt === ExceptionTypeInt.MetricKitCrash) {
    return 'metrickit-crash';
  }
  if (exceptionTypeInt === ExceptionTypeInt.MetricKitCpu) {
    return 'metrickit-cpu';
  }
  if (exceptionTypeInt === ExceptionTypeInt.MetricKitDisk) {
    return 'metrickit-disk';
  }
  if (exceptionTypeInt === ExceptionTypeInt.AexitCrash) {
    return 'aexit-crash';
  }
  if (exceptionTypeInt === ExceptionTypeInt.AexitAnr) {
    return 'aexit-anr';
  }
  return 'errors';
}
